<div *ngIf="contentInfo?.isShowFooterNote === 'true'" class="external-link">
  <span>
    <img [src]="contentInfo?.footerTextImgPath" alt="External Site" />
  </span>
  <p
    [innerHTML]="
      contentInfo && contentInfo.footerExtDesc ? contentInfo.footerExtDesc : ''
    "
  ></p>
</div>
<div class="footer-info">
  <p
    [innerHTML]="
      (contentInfo && contentInfo.copyRight ? contentInfo.copyRight : '') +
      '<span>|</span>' +
      (contentInfo && contentInfo.disClaimer1 ? contentInfo.disClaimer1 : '')
    "
  ></p>
  <p
    [innerHTML]="
      contentInfo && contentInfo.disClaimer2 ? contentInfo.disClaimer2 : ''
    "
  >
    <!-- Terms and conditions apply to all offers and SkyMiles benefits. See specific offer for details, and visit <a href="#">SkyMiles Membership Guide &amp; Program Rules -->
  </p>
</div>
